import React from 'react';

import Box from '../Box/Box';
import Title5 from '../Title/Title5';
import { Link } from '../Link';
import TertiaryIconButton from '../IconButton/Tertiary';

import TModalHeader from './@types/TModalHeader';

const ModalHeader = ({ title, label, onClose, onBack, onLabelClick, headerAction }: TModalHeader) => (
  <Box as="div" parent="Modal" name="Header">
    <Box as="div" parent="Modal-Header" name="Button">
      {headerAction === 'BACK' || (!headerAction && onBack) ? (
        <TertiaryIconButton onClick={onBack} name="back" ariaLabel="Back" />
      ) : (
        <TertiaryIconButton onClick={onClose} name="close-small" ariaLabel="Close" />
      )}
    </Box>
    {title && <Title5>{title}</Title5>}
    <Box as="div" parent="Modal-Header" name="Button">
      {label && <Link onClick={onLabelClick}>{label}</Link>}
    </Box>
  </Box>
);

export default ModalHeader;
